<script setup>
const props = defineProps({
  emoji: {
    type: String,
    required: true,
  },
})

const baseEmojiUrl = `${import.meta.env.VUE_APP_PUBLIC_ASSETS_URL || ''}/emojis`
</script>

<template>
  <img class="base-emoji" :src="`${baseEmojiUrl}/${props.emoji}`">
</template>

<style lang="scss">
.base-emoji {
  height: 1em; // Default value in order to emulate a real unicode emoji.

  aspect-ratio: 1;
}
</style>
